import validate from 'mixins/validate';
import 'lib/vue-phone-input.js';
import { decode } from 'utils/general';

export default {
  props: ['questions-object'],
  components: {
    'text-area': () => import('../text-area/text-area.vue'),
    'select-input': () => import('../select-input/select-input.vue'),
  },
  data() {
    const questionsData = JSON.parse(decode(this.questionsObject));
    return {
      phoneValue: this.phone,
      phoneCountry: '',
      phoneValid: false,
      phoneActive: false,
      questions: questionsData || {},
    };
  },
  mixins: [validate],
  mounted() {
    const fadeInEl = document.querySelector('.js-fade-container');

    if (fadeInEl) {
      fadeInEl.classList.add('initialized');
    }
  },
  computed: {
    optionName() {
      return { name: 'contact[Phone]' };
    },
  },
  methods: {
    sendContactForm(event) {
      event.preventDefault();

      const form = this.$el.querySelector('.contact-form');

      form.classList.add('is-loading');
      this.$refs['submitButton'].disabled = true;
      if (!this.validateCustomForm()) {
        form.classList.remove('is-loading');
        this.$refs['submitButton'].disabled = false;
      } else {
        const self = this;
        const questionsDropdown = this.$refs['questionsDropdown'];
        window.dataLayer.push({
          event: 'help_center_contact_us_form',
        });
        window.dataLayer.push({
          event: 'contactRequest',
          contactType: 'Contact form',
          requestType: questionsDropdown.inputValue,
          eventCallback: () => {
            form.submit();
          },
        });
      }
    },
    highlightErrors(element, isValid) {
      if (!isValid) {
        element.dirty = true;
        element.isValid = false;

        window.dataLayer?.push({
          event: 'error_captured',
          error_message: element._props.error,
        });
      }
    },
    validateCustomForm() {
      const checkPhone = this.phoneValidation();
      const questionsDropdown = this.$refs['questionsDropdown'];
      const comment = this.$refs['comment'];

      let isValid = this.$children
        .filter((c) => typeof c.validateInput !== 'undefined')
        .map((c) => {
          const validInput = c.validateInput();
          this.highlightErrors(c, validInput);

          return c.validateInput();
        })
        .every((res) => res);

      // check if comment textarea is not empty
      if (!comment.inputValue) {
        comment.isValid = false;
        isValid = false;
        window.dataLayer?.push({
          event: 'error_captured',
          error_message: '*message is required',
        });
      }

      // check if options select dropdown is not empty
      if (questionsDropdown.inputValue === 'placeholder') {
        questionsDropdown.isValid = false;
        isValid = false;
        window.dataLayer?.push({
          event: 'error_captured',
          error_message: '*cannot be empty',
        });
      }

      // check if user added a phone and if its valid
      if (!checkPhone) {
        isValid = false;

        this.phoneValidation(true);
      }

      return isValid;
    },
    phoneValidation(output = false) {
      const classesRemove = ['has-errors', 'has-errors--alt'];
      const phoneInput = this.$refs['phone'];

      if (!this.phoneValue) {
        if (output) {
          phoneInput.classList.remove(...classesRemove);
        }

        return true;
      }

      if (this.phoneValue && !this.phoneValid) {
        if (output) {
          phoneInput.classList.remove(...classesRemove);
          phoneInput.classList.add('has-errors');
        }

        return false;
      }

      if (output) {
        phoneInput.classList.remove(...classesRemove);
      }

      return true;
    },
    phoneOnChange(value) {
      if (value) {
        this.phoneActive = true;
      }

      this.phoneValidation(true);
    },
    phoneCountryChange(event) {
      const countryIsoCode = event.iso2;
      this.phoneCountry = countryIsoCode;
    },
    phoneFocus() {
      this.phoneActive = true;
    },
    phoneBlur() {
      if (!this.phoneValue) {
        this.phoneActive = false;

        this.phoneValidation(true);
      }
    },
    validatePhone(event) {
      this.phoneValid = event.valid;
      this.phoneValidation(true);
    },
    onInputChange({ name, value }) {
      const match = /\[(\w*)\]/.exec(name);
      const questionsDropdown = this.$refs['questionsDropdown'];
      const comment = this.$refs['comment'];

      if (!match || !match[1]) {
        return false;
      }

      switch (match[1]) {
        case 'body':
          comment.isValid = !!value;
          break;
        case 'About':
          questionsDropdown.isValid = true;
          break;
        default:
          break;
      }
    },

    generateQuestions() {
      return Object.keys(this.questions).map((label) => ({
        label,
        value: label,
      }));
    },
  },
};
